const Mutations = {
    setLoader(state, value) {
        state.loader = value
    },
    setPageCurrentLocation(state, current) {
        state.page.current.name = current.name
        state.page.current.number = current.number
    },
    setPageTitle(state, newTitle) {
        state.page.title = newTitle
    },
    setPageBreadCrumb(state, newBreadCrumb=[]) {
        state.page.breadcrumb = newBreadCrumb
    },
    ExpandBurger(state, value) {
        state.page.menu.expand = value
    },
    setCookies(state, value) {
        state.cookies = value
    },
    setServerInfo(state, info) {
        state.server.gs = info.gs
        state.server.cs = info.cs
    },
    setMemberStatus(state, newMemberStatus) {
        state.memberStatus = newMemberStatus
    },
    setTop3PlayerRank(state, newRank) {
        state.shortRank.player = newRank
    },
    setTop3GuildRank(state, newRank) {
        state.shortRank.guild = newRank
    },
    setTop3PkerRank(state, newRank) {
        state.shortRank.pker = newRank
    },
    changeDashboardPage(state, newPage) {
        state.dashboard.page = newPage
    },
    changeDashboardCharacter(state, newCharacter) {
        state.dashboard.character = newCharacter
    },
    changeDashboardCharacterDirection(state, newDirection) {
        state.dashboard.characterDirection.left = newDirection.left
        state.dashboard.characterDirection.right = newDirection.right
    },
    openOnlineModal(state) {
        state.modals.online = true
    },
    closeOnlineModal(state) {
        state.modals.online = false
    }
    
}

export default Mutations;